var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('br'),_c('center',[_c('h1',[_vm._v("Error 404")]),_c('h3',[_vm._v("Página no encontrada")]),_c('br'),_c('br'),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.back}},[_vm._v("Volver")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }